import { Component, OnInit } from '@angular/core';
import { BreadCrumbService } from '../../../services/bread-crumb.service';
import { Breadcrumb } from '../../../models/breadcrumb';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'migo-apps-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [];
  constructor(
    private readonly breadcrumbSvc: BreadCrumbService,
    public readonly router: Router
  ) {}
  ngOnInit(): void {
    this.breadcrumbSvc.breadcrumbs$.subscribe((breadcrumbs) => {
      this.breadcrumbs = breadcrumbs;
    });
  }
}
